import useStyles from '../../Register/RegistrationForm/RegistrationForm.layout.styles';
import RegistrationHeader from '../../Register/RegistrationHeader/RegistrationHeader';
import RegistrationFooter from '../../Register/RegistrationFooter/RegistrationFooter';
import { Typography } from '@material-ui/core';
import { CLOUD_DISPLAY_LOOKUP } from '../../../utils/constants';

export const AlreadyRegistered = ({ supportEmail = '', product, vendor }) => {
  const classes = useStyles();
  const cloud = product?.cloud;
  const listingName = product?.name;
  const vendorName = vendor?.name;

  const listingNameDisplay = !!listingName ? ` for ${listingName}` : '';
  const vendorNameDisplay = vendorName || 'the vendor';
  const cloudDisplay = CLOUD_DISPLAY_LOOKUP[cloud] || '';
  const hasSupportEmail = !!supportEmail;

  return (
    <>
      <div className={classes.container}>
        <RegistrationHeader />

        <div className={classes.formContainer}>
          <Typography variant="h5" gutterBottom>
            You’re already registered
          </Typography>
          <Typography variant="body1" gutterBottom>
            You or someone in your organization already registered
            {listingNameDisplay} from this {cloudDisplay} Marketplace account.
            To make changes to your current subscription or if you have any
            questions, please contact {vendorNameDisplay}
            {hasSupportEmail ? (
              <>
                {' '}
                at{' '}
                <a
                  href={`mailto:${supportEmail}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {supportEmail}
                </a>
                .
              </>
            ) : (
              <>.</>
            )}
          </Typography>
        </div>

        <RegistrationFooter />
      </div>
    </>
  );
};

export default AlreadyRegistered;
